import { Tabs as AntTabs } from 'antd';
import styled from 'styled-components';
import { theme } from '../../theme/semanticTokens';
import type { TabsOrientation } from './Tabs';

export const TabLabelContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${theme.dime.spacing.m};
`;

export const StyledTabs = styled(AntTabs)<{ $orientation: TabsOrientation }>`
  &.ant-tabs {
    color: ${theme.dime.colors.text.primary};
  }

  .ant-tabs-nav::before {
    border-color: ${theme.dime.colors.border.static};
  }

  .ant-tabs-nav-list {
    gap: ${theme.dime.spacing.xl};
  }

  .ant-tabs-tab {
    margin: 0 !important;
    padding: ${theme.dime.spacing.m} 0;
    font-family: ${theme.dime.fonts.families.roboto};
    font-size: ${theme.dime.fonts.sizes.sm};
    line-height: ${theme.dime.fonts.lineHeights.sm};

    .ant-tabs-tab-btn {
      color: ${theme.dime.colors.text.primary};
      font-weight: ${theme.dime.fonts.weights.regular};
    }

    &:hover:not(.ant-tabs-tab-disabled):not(.ant-tabs-tab-active)
      .ant-tabs-tab-btn {
      color: ${theme.dime.colors.text.brandHover};
    }

    .anticon {
      margin-right: 0;
    }
  }

  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      color: ${theme.dime.colors.link.primary} !important;
    }
  }

  .ant-tabs-tab-disabled {
    cursor: not-allowed;

    .ant-tabs-tab-btn {
      color: ${theme.dime.colors.text.disabled} !important;
      cursor: not-allowed;
    }
  }

  .ant-tabs-ink-bar {
    background: ${theme.dime.colors.border.interactiveSelected};
  }

  &.ant-tabs-top,
  &.ant-tabs-bottom {
    .ant-tabs-nav-list {
      gap: ${theme.dime.spacing['2xl']};
    }

    .ant-tabs-ink-bar {
      height: 2px;
    }
  }

  &.ant-tabs-left,
  &.ant-tabs-right {
    .ant-tabs-nav-list {
      gap: ${theme.dime.spacing.s};
    }

    .ant-tabs-tab {
      padding: ${theme.dime.spacing.s} ${theme.dime.spacing.l};
    }

    .ant-tabs-ink-bar {
      width: 2px;
    }
  }
`;
